/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProgramMonthlyReportAgeGroup } from './ProgramMonthlyReportAgeGroup';
import type { ProgramMonthlyReportProgressByCategoryDto } from './ProgramMonthlyReportProgressByCategoryDto';
import type { ProgramTaskActionType } from './ProgramTaskActionType';

export type ProgramMonthlyReportDto = {
    ageGroup: ProgramMonthlyReportAgeGroup;
    bestActions?: Array<ProgramTaskActionType>;
    worstActions?: Array<ProgramTaskActionType>;
    disabledActions?: Array<ProgramTaskActionType>;
    gender: ProgramMonthlyReportDto.gender;
    monthNumber: number;
    date: string;
    amountOfCheckins: number;
    prevAmountOfCheckins?: number;
    percentOfCheckins: number;
    prevPercentOfCheckins?: number;
    percentDiff?: number;
    expectedPercentOfCheckins?: number;
    nextExpectedPercent: number;
    progressByAction: Array<ProgramMonthlyReportProgressByCategoryDto>;
};

export namespace ProgramMonthlyReportDto {

    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
    }


}

